import React from "react";

import { Icon, IconName, Row } from "../lib";

type Props = {
  value: number;
};

export function RatingScore({ value }: Props) {
  const valueRounded = Math.round(value);

  const content = [];

  for (let i = 1; i < 6; i++) {
    let icon: IconName;

    if (i <= value) {
      icon = "star";
    } else if (i <= valueRounded && value - valueRounded < 0) {
      icon = "star-half";
    } else {
      icon = "star-outline";
    }

    content.push(<Icon key={`star-${i}`} name={icon} em />);
  }

  return <Row.L>{content}</Row.L>;
}
